export function formatPrice(price: number): string {
  if (price < 10) {
    return price.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  } else if (price < 1000) {
    return price.toLocaleString(undefined, {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    });
  } else if (price < 10_000) {
    return price.toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  } else {
    return price.toLocaleString(undefined, {
      currency: 'USD',
      notation: 'compact',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  }
}

export function formatOptionPrice(price: number): string {
  // Enforce minimum price of $0.01
  const minPrice = Math.max(price, 0.01);

  if (minPrice < 0.1) {
    // Show 3 decimal places for very small prices (< $0.10)
    return minPrice.toLocaleString(undefined, {
      minimumFractionDigits: 3,
      maximumFractionDigits: 3,
    });
  } else if (minPrice < 1.0) {
    // Show 3 decimal places for prices under $1
    return minPrice.toLocaleString(undefined, {
      minimumFractionDigits: 3,
      maximumFractionDigits: 3,
    });
  } else if (minPrice < 10) {
    // Show 2 decimal places for prices $1-$10
    return minPrice.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  } else {
    // Show 1 decimal place for higher prices
    return minPrice.toLocaleString(undefined, {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    });
  }
}
